import Swiper, {Navigation} from "swiper"

export default (el) => {
  const swiperEl = el.querySelector('.js-p-component-partner')

  new Swiper(swiperEl, {
    modules: [Navigation],
    slidesPerView: 2.3,
    spaceBetween: 16,
    breakpoints: {
      375: {
        slidesPerView: 3.3,
        navigation: false,
      },
      640: {
        slidesPerView: 5.3,
        navigation: false,
      },
      1024: {
        slidesPerView: 6.3,
        navigation: false,
      },
      1200: {
        slidesPerView: 6,
        navigation: {
          nextEl: ".partner-next",
          prevEl: ".partner-prev",
        },
      }
    },
  })
}
